import { render, staticRenderFns } from "./CustomWorkConfirmation.vue?vue&type=template&id=53e711f4&"
import script from "./CustomWorkConfirmation.vue?vue&type=script&lang=js&"
export * from "./CustomWorkConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./CustomWorkConfirmation.vue?vue&type=style&index=0&id=53e711f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports